import {getCountries} from "./countries";
import agent from "../../agent/agent";
import dictionaryRuEn from "../../constants/dictionary-ru-en.json";
import dictionaryEnRu from "../../constants/dictionary-en-ru.json";
import {getItemFromLocalStorage, setItemFromLocalStorage} from "../../utils/localstorage";

const GET_FAQ = "faq/GET_FAQ";

const initStage = {
	items: [],
	isLoading: true
};

function findBlockByName(placeholders, blockName) {
	if (!placeholders) return null
	for (const key in placeholders) {
		const blocks = placeholders[key]
		if (Array.isArray(blocks)) {
			for (const block of blocks) {
				if (block?.block_name === blockName) return block
				if (block?.placeholders) {
					const found = findBlockByName(block.placeholders, blockName)
					if (found) return found
				}
			}
		}
	}
	return null
}

export function getFaqItems () {
	return async function (dispatch) {
		const res = await agent.get('/api/cms/page-by-path?path=/faq')
			.then((res) => res.data).catch(() => null)
		const faqBlock = findBlockByName(res?.placeholders, 'FaqBlock')
		dispatch({
			type: GET_FAQ,
			value: faqBlock?.extras?.items || []
		})
	}
}

export default function ProfileState (state = initStage, action = {}) {
	switch (action.type) {
		case GET_FAQ: {
			return {
				...state,
				items: action?.value || [],
				isLoading: false
			}
		}
		default:
			return state;
	}
}
